import React, { useState, useEffect } from 'react';
import './ScriptForm.css';

function ScriptForm({ script, onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    script: '',
    system_script: '',
    active: true
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (script) {
      // Editing existing script
      setFormData({
        name: script.name || '',
        description: script.description || '',
        script: script.script || '',
        system_script: script.system_script || '',
        active: script.active !== undefined ? script.active : true
      });
    } else {
      // Creating new script
      setFormData({
        name: '',
        description: '',
        script: '',
        system_script: '',
        active: true
      });
    }
  }, [script]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.description.trim() || !formData.script.trim()) {
      alert('Please fill in all required fields');
      return;
    }

    setLoading(true);
    try {
      await onSubmit(formData);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error saving script. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="script-form-overlay">
      <div className="script-form-modal">
        <div className="form-header">
          <h2>{script ? 'Edit Prompt Script' : 'Create New Prompt Script'}</h2>
          <button onClick={handleCancel} className="close-button">
            <i className="ti ti-x"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="script-form">
          <div className="form-row">
            <div className="script-form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter script name"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="script-form-group">
              <label htmlFor="description">Description *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter script description"
                rows="3"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="script-form-group">
              <label htmlFor="script">Script *</label>
              <textarea
                id="script"
                name="script"
                value={formData.script}
                onChange={handleChange}
                placeholder="Enter the prompt script content"
                rows="12"
                required
                className="script-textarea"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="script-form-group">
              <label htmlFor="system_script">System Script (Optional)</label>
              <textarea
                id="system_script"
                name="system_script"
                value={formData.system_script}
                onChange={handleChange}
                placeholder="Enter system script content (optional)"
                rows="6"
                className="script-textarea"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="script-form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                />
                <span className="checkmark"></span>
                Active
              </label>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={handleCancel}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className="ti ti-loader ti-spin"></i>
                  Saving...
                </>
              ) : (
                script ? 'Update Script' : 'Create Script'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ScriptForm; 